export const COMPLETION_FIELD_NAME = 'completionSettings' as const;
export const COMPLETION_THRESHOLD_DEFAULT_VALUE = 80 as const;
export const ABSENT_THRESHOLD_DEFAULT_VALUE = 20 as const;
export const INFO_ICON_FILL = 'var(--icon-primary)' as const;
